import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';

export class historico{
  activityId?: number;
  period?: string;
  planned?: number;
  executed?: number;
}
export class actividades{
  public name?: string;
  public initial_date?: Date;
  public end_date?: Date;
  public projectId?: number;
  public responsibleId?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ActividadService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'))
    
  constructor(
    private readonly cookies: CookieService,
    private readonly http: HttpClient,
    private readonly apollo: Apollo,
  ) { }

  public postActividades(act: any): Observable<any>{
    const acti: actividades = {
      projectId: Number(act.projectId),
      initial_date: act.fecha_inicio.toISOString(),
      end_date: act.fecha_fin.toISOString(),
      name: act.nombre,
      responsibleId: Number(act.responsibleId),
    }
    const body = JSON.stringify(acti);
    const apiURL = this.apiURL+"actividad";
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }

  public patchActividades(act: any): Observable<any>{
    const acti: actividades = {
      initial_date: act.fecha_inicio.toISOString(),
      end_date: act.fecha_fin.toISOString(),
      name: act.nombre,
      projectId: Number(act.projectId),
      responsibleId: Number(act.responsibleId),
    }
    const body = JSON.stringify(acti);
    const apiURL = this.apiURL+"actividad/"+act.id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }

  public deleteActividades(act: any): Observable<any>{
    const apiURL = this.apiURL+"actividad/"+act.id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }

  public deleteHistory(act: any, his: any): Observable<any>{
    const apiURL = this.apiURL+"actividad/"+act.id+"/history/"+his.id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }

  public DeleteHistorico(his: any, idAct: number, idHis: number): Observable<any>{
    const apiURL = this.apiURL+"actividad/"+idAct+"/history/"+idHis;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }

  public getActividadesActas(): Observable< any >{
    const apiURL = this.apiURL+"acta/actividades";
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }

  public getActividadesId(id: any): Observable< any >{
    const apiURL = this.apiURL+"actividad/"+id;
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }

  public postHistorico(his: any, idAct: number): Observable<any>{
      const hist: historico = {
        // activityId: idAct,
        // period: `20${his.periodo.split('-')[1]}-${Meses.getMesesNum(his.periodo.split('-')[0])}`,
        period: his.periodo,
        planned: Number(his.planeado),
        executed: his.ejecutado,
      }
      const body = JSON.stringify(hist);
      const apiURL = this.apiURL+"actividad/"+idAct+"/history";
      return this.http.post(`${apiURL}`, body, {headers: this.headers});
    }
  
    public PatchHistorico(his: any, idAct: number, idHis: number): Observable<any>{
      const hist: historico = {
        period: his.periodo,
        planned: Number(his.planeado),
        executed: his.ejecutado,
      }
      const body = JSON.stringify(hist);
      const apiURL = this.apiURL+"actividad/"+idAct+"/history/"+idHis;
      return this.http.patch(`${apiURL}`, body, {headers: this.headers});
    }
  
    public PatchHistoricoNull(his: any, idAct: number, idHis: number): Observable<any>{
      const hist: historico = {
        period: his.period,
        planned: Number(his.planned),
        executed: his.executed,
      }
      const body = JSON.stringify(hist);
      const apiURL = this.apiURL+"actividad/"+idAct+"/history/"+idHis;
      return this.http.patch(`${apiURL}`, body, {headers: this.headers});
    }

}
